export default {"src":"/_next/static/media/welkin-and-meraki.3e549d5a.svg","height":20,"width":370,"blurWidth":0,"blurHeight":0};